/* eslint-env browser */
import React, {
  FC, useEffect, useState, useRef, memo,
} from 'react';
import { setCopyToClipboard } from '@aarhus-university/au-designsystem-delphinus/source/js/components/nav';
import { useLangContext, useUserContext } from '@aarhus-university/au-lib-react-components/src/lib/context';
import { useTranslationsContext } from '../../lib/translation';
import { useImpersonationContext } from '../../lib/context';

const ProfileWidgetComponent: FC = memo(() => {
  const [ctcSet, setCtcSet] = useState<boolean>(false);
  const copyAuIdRef = useRef<HTMLButtonElement>(null);
  const copyStudentNumberRef = useRef<HTMLButtonElement>(null);
  const lang = useLangContext();
  const translations = useTranslationsContext();
  const userContext = useUserContext();
  const { isStudent, isApplicant, isImpersonator } = useImpersonationContext();
  const { auId, name, studentNumber } = userContext || {};
  const noAccess = !isStudent && !isApplicant && !isImpersonator;

  useEffect(() => {
    if (auId && auId > 0 && !ctcSet) {
      if (copyAuIdRef) {
        setCopyToClipboard(copyAuIdRef.current as HTMLElement);
      }
      if (studentNumber && copyStudentNumberRef && !noAccess) {
        setCopyToClipboard(copyStudentNumberRef.current as HTMLElement);
      }
      setCtcSet(true);
    }
  }, [ctcSet]);

  return (
    <div className="sub-nav__content theme--normal" aria-labelledby="profile-menu-toggle">
      <div className="sub-nav__user">
        <h2 className="sub-nav__user-name">{name}</h2>
        <button
          ref={copyAuIdRef}
          type="button"
          className="copy-to-clipboard"
          aria-label={`${translations.generics.user.au_id}: AU${auId}`}
          data-gtm="au-btn-header-copy-auid"
        >
          {`${translations.generics.user.au_id}: `}
          <span className="copy-to-clipboard__this">{`AU${auId}`}</span>
          <span className="copy-to-clipboard__hint" aria-hidden="true">{translations.generics.user.copy_auid}</span>
        </button>
        {
          (studentNumber && !noAccess) && (
            <button
              ref={copyStudentNumberRef}
              type="button"
              className="copy-to-clipboard"
              aria-label={`${translations.generics.user.student_registration_number}: ${studentNumber}`}
            >
              {`${translations.generics.user.student_registration_number}: `}
              <span className="copy-to-clipboard__this">{studentNumber}</span>
              <span className="copy-to-clipboard__hint" aria-hidden="true">{translations.generics.user.copy_student_number}</span>
            </button>
          )
        }
      </div>
      {
        !noAccess && (
          <>
            <hr />
            <a
              className="sub-nav__item"
              href={`/${lang}/profile`}
            >
              {translations.generics.sub_nav.profile_settings}
            </a>
            <a
              className="sub-nav__item--icon"
              href={`/${lang}/password`}
            >
              {translations.generics.sub_nav.change_password}
            </a>
            <hr />
            <a className="sub-nav__item sub-nav__item--icon" href={`/${lang}/profile/language`} data-icon="" data-gtm="au-btn-header-profile-changelanguage">{translations.generics.sub_nav.change_language}</a>
          </>
        )
      }
      <hr />
      <a
        className="sub-nav__item sub-nav__item--icon"
        href="/MicrosoftIdentity/Account/SignOut"
      >
        {translations.generics.authentication.sign_out}
      </a>
    </div>
  );
});

ProfileWidgetComponent.displayName = 'ProfileWidgetComponent';
export default ProfileWidgetComponent;
